import useSWR from 'swr'
import { API } from '../api'

export type WidgetOptions = {
  operation?: 'link' | 'unlink'
  nextStep?: string
  [key: string]: unknown
}

export type InfoPayload = {
  envId: string
  apiKey: string
  tenant: string
  entityId: string
  flow: string
  type: string
  jwt: string
  operation?: 'link' | 'unlink'
  options: WidgetOptions
}

const useToken = (token: string) => {
  const { data, error, isLoading } = useSWR<InfoPayload, string>(
    token ? [`/magicLink/connection?token=${token}`, undefined, API.CLIENT] : null,
    {
      shouldRetryOnError: false,
    }
  )

  return { data, error, isLoading }
}

export default useToken
